const categories = {
  addEditCategory: {
    addPageTitle: "Add Category",
    editPageTitle: "Edit Category",
    categoryDetailsTitle: "Category Details",
    websiteCoverImagePlaceholder: "Category cover",
    adminCoverImagePlaceholder: "Category image",
    inputLabels: {
      categoryName: "Category Name",
      categoryDescription: "Category Description"
    },
    placeholders: {
      categoryNamePlaceholder: "Enter Category name",
      categoryDescriptionPlaceholder: "Enter Category description"
    }
  },
  list: {
    categoriesList: "Categories List",
    category: "Category",
    categories: "Categories",
    tableHeader: {
      category: "Category",
      description: "Description",
      subCategories: "Sub Categories"
    },
    addMoreCategories: "Add Category",
    noCategoriesFound: "There is no categories found",
    noSearchResults:
      "There is no search result that matches the entered data.",
    searchPlaceholder: "Search by Category Name"
  },
  categoryDetails: {
    categoryDetailsTitle: "Category Details",
    subCategories: "Sub Categories",
    subCategory: "Sub Category",
    addMoreSubCategories: "Add Sub Category",
    noSubCategoriesFound: "There is no Sub Categories found",
    noSearchResults:
      "There is no search result that matches the entered data.",
    searchPlaceholder: "Search by Sub Category Name",
    tableHeader: {
      subCategory: "Sub Category",
      description: "Description",
      products: "Products"
    }
  },
  deleteCategory: {
    content: "Delete",
    confirmationContent:
      "Are you sure you want to delete this Category ?",
    subConfirmationContent: " This action cannot be undone."
  },
  categoriesRequests: {
    categoriesRequests: "Categories Requests",
    categories: "Categories",
    category: "Category",
    addCategory: "Add Category",
    pending: "Pending",
    rejected: "Rejected",
    searchPlaceholder: "Search by category name",
    emptyPlaceholder: "No category requests yet",
    emptyRejectedPlaceholder: "No rejected category requests yet",
    table: {
      category: "Category",
      description: "Description",
      companyName: "Company Name",
      userType: "User Type",
      requestDate: "Request Date",
      rejectDate: "Rejection Date",
      rejectAccept: "Reject / Accept",
      importer: "Importer",
      exporter: "Exporter",
      both: "Both"
    },
    filters: {
      userType: "User Type",
      companyName: "Company Name",
      dateRange: "Date Range",
      searchCompanyName: "Search by company name"
    },
    requestDetails: {
      categoryRequestDetails: "Category Request Details",
      categoryName: "Category Name",
      description: "Decription",
      requestedBy: "Requested By",
      noRequestFound: "No Request Found"
    },
    requestActions: {
      acceptConfirmTitle:
        "Are you sure you want to accept “:categoryName”?",
      acceptConfirmMsg:
        "you need to upload cover image before accept the caregory",
      acceptWithModification: "Accept With Modification",
      rejectConfirmTitle:
        "Are you sure you want to reject “:categoryName”?"
    },
    rejectRequest: {
      btnLabel: "Reject",
      title: `Are you sure you want to Reject ":categoryName"?`,
      rejectionReason: "Rejection Reason",
      typeHere: "Type Here"
    }
  }
};

export default categories;
